/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import GuideCharacter from '@assets/images/bg/character/betting-cancel.png'
import { CharacterDialog } from '@views/Popup/Dialog/CharacterDialog'

export const KakaoServiceTerminationInfo: React.FC = observer(() => {
  const img = <img src={GuideCharacter} alt="캐릭터" className="guide-character" loading="lazy"/>
  const title = (
    <p className="guide-txt big">
      카카오 서비스 종료
    </p>
  )
const body = (
  <div className="guide-box small ">
    이관 신청한 회원님은 선택했던 계정으로<br/>
    로그인하여 이용하시면 됩니다.
    <br/><br/>
    이관 신청하지 못한 회원님은 1:1 문의 또는<br/>
    <span className="point-color--orange--modal">help@adventurer.co.kr</span>로 문의주시면<br/>
    감사하겠습니다.
  </div>
)

  return (<CharacterDialog characterImg={img} title={title} body={body}/>)
})
